import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=5ae00adb&lang=pug"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"
import style0 from "./EditAccount.vue?vue&type=style&index=0&id=5ae00adb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports